import { render, staticRenderFns } from "./applyDeliverDetail.vue?vue&type=template&id=8869a35c&scoped=true"
import script from "./applyDeliverDetail.vue?vue&type=script&lang=js"
export * from "./applyDeliverDetail.vue?vue&type=script&lang=js"
import style0 from "./applyDeliverDetail.vue?vue&type=style&index=0&id=8869a35c&prod&lang=scss&scoped=true"
import style1 from "./applyDeliverDetail.vue?vue&type=style&index=1&id=8869a35c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8869a35c",
  null
  
)

export default component.exports